import React from "react";
import { Helmet } from "react-helmet";
import Header from "../../../components/default/header";
import SidebarMenu from "../menu/newLeadSidebarMenu";
import NewLeadForm from "./leadForm";
import Breadcrumb from "../../default/breadcrumb/breadcrumb";


const CreateNewLead = () => {
    return (
        <div className="menu-with-settings sidebar-menu-enable">
            <Helmet><title>Add new lead</title></Helmet>
            <Header />
            <div className="sidebar-with-content ds-flex">
                <SidebarMenu />
                <div className="content-right">
                    <Breadcrumb />
                    <NewLeadForm />
                </div>
            </div>
        </div>
        
    );
}

export default CreateNewLead;
